module.exports = __webpack_public_path__ + "img/CWM-WebsiteTiles-EOTAS-F01-Letter-72dpi.a55ddcfa.jpg";